/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import ProjectsRoot from '~components/pages/ProjectsRoot';
import PublicShare from '~components/pages/PublicShare/PublicShare';
import PublicShareTenders from '~components/pages/PublicShareTenders/PublicShareTenders';
import LoginPage from '~components/pages/Login';
import MyProjects from '~components/pages/MyProjects';
import NotFoundPage from '~components/pages/404';
import { ProjectsRootMobile } from './ProjectsRootMobile';
import MobileViewContext, {
  MobileViewCtx,
} from '~src/contexts/MobileViewContext';
import { useEffect, useMemo, useState } from 'react';
import { mobileCheck } from '~src/utils/mobileCheck';
import { appLog } from '~src/utils/log';
import SearchContextProvider from '~src/contexts/SearchContext';
import { webAppPath } from '~src/services/api/api-cweb';
import { DocumentTitleManager } from '~components/atoms/DocumentTitleManager/DocumentTitleManager';

/** Root navigation */
const Root = () => {
  const { status } = useThemeSwitcher();
  // const showMobile = true;
  // const [showMobile, setShowMobile] = useState(true);

  const [showMobileView, setShowMobileView] = useState<
    MobileViewCtx['showMobileView']
  >(false);

  const showMobileViewContextChanged = useMemo(
    () => ({ showMobileView, setShowMobileView }),
    [showMobileView, setShowMobileView]
  );

  useEffect(() => {
    const isMobile = mobileCheck();

    appLog('===isMobile===> ', isMobile);

    if (isMobile) {
      setShowMobileView(true);
    }
  }, []);

  // Avoid theme change flicker
  if (status === 'idle' || status === 'loading') {
    return null;
  }

  // we redirect the user to the webapp, from where can be sent forward to the login page
  const WebAppPath = () => {
    window.location.href = webAppPath;
    return null;
  };

  return (
    <MobileViewContext.Provider value={showMobileViewContextChanged}>
      <SearchContextProvider>
        <BrowserRouter>
          <DocumentTitleManager />
          {/* is mobile ------ {String(mobileCheck())} */}
          <Switch>
            <Route
              path="/projects"
              component={showMobileView ? ProjectsRootMobile : ProjectsRoot}
            />

            {/* Public Share route */}
            <Route path="/shares/:shareId" component={PublicShare} />
            <Route path="/tenders/:shareId" component={PublicShareTenders} />
            <Route path="/login" component={LoginPage} />

            <Route path="/404" component={NotFoundPage} />

            {/* Go back to WebApp route */}
            <Route path="/" component={MyProjects} />

            {/* <WebAppPath /> */}
            {/* </Route> */}

            <Redirect to={'/404'} />
          </Switch>
        </BrowserRouter>
      </SearchContextProvider>
    </MobileViewContext.Provider>
  );
};

export default Root;
